<template>
    <activation-preview-provider
        v-slot="{
            brief,
            step,
        }"
        :module-name="moduleName"
    >
        <activation-brief-products-view
            v-if="brief"
            :brief="brief"
            :step="step"
            :is-preview="true"
        />
        <g-loader v-else type="fixed" />
    </activation-preview-provider>
</template>

<script>
    import ActivationPreviewProvider from '../../providers/preview-providers/ActivationPreviewProvider';
    import ActivationBriefProductsView from '../../data-views/activation-briefs/ActivationBriefProductsView';
    import PageMask from '../../library/PageMask';
    import {NAME_PRODUCTS} from '../../../constants/activation-brief-steps';

    export default {
        name:       'ActivationProductsPreviewRouterView',
        components: {
            ActivationBriefProductsView,
            ActivationPreviewProvider,
            PageMask,
        },
        data(){
            return {
                moduleName: NAME_PRODUCTS,
            };
        },
    };
</script>
